"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileService = void 0;
const operators_1 = require("rxjs/operators");
const restservice_1 = require("./restservice");
class ProfileService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        // url = '/rest/model/atg/userprofiling/ProfileActor/detailed';
        this.cartCountUrl = '/rest-api/cart/v1/itemCount';
    }
    /// need confirmation
    // getProfile(): any  {
    //   return this.get(this.url)
    //         .map((data: any) => {
    //             return data.profile;
    //         });
    // }
    getCartCount() {
        return this.get(this.cartCountUrl).pipe(operators_1.map((data) => {
            this.cartInfo = data;
            return data;
        }));
    }
}
exports.ProfileService = ProfileService;
//# sourceMappingURL=profile.service.js.map